import { useState, type ReactNode } from "react";
import AdminShellSidebar from "./AdminShellSidebar";
import AdminShellTopBar from "./AdminShellTopBar";
import AdminButton from "../common/AdminButton";

interface AdminPageLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  actions?: ReactNode;
  contentTop?: "default" | "compact";
  hasIssue?: boolean;
  issueLabel?: string;
}

const AdminPageLayout = ({
  title,
  subtitle,
  children,
  actions,
  contentTop = "default",
  hasIssue = false,
  issueLabel = "확인 필요",
}: AdminPageLayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen w-full flex" style={{ background: "#f3f6fb", fontFamily: '"Noto Sans KR", sans-serif' }}>
      <AdminShellSidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileSidebarOpen}
        onCloseMobile={() => setMobileSidebarOpen(false)}
        onToggle={() => setSidebarCollapsed((value) => !value)}
      />

      {mobileSidebarOpen && (
        <AdminButton variant="plain" size="auto"
          type="button"
          aria-label="관리자 메뉴 닫기"
          className="fixed inset-0 z-30 bg-slate-950/50 backdrop-blur-sm lg:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      <div className={`flex min-h-screen min-w-0 flex-1 flex-col transition-[margin] duration-300 ${sidebarCollapsed ? "lg:ml-[4.5rem]" : "lg:ml-[16.5rem]"}`}>
        <AdminShellTopBar
          sidebarCollapsed={sidebarCollapsed}
          onOpenMobile={() => setMobileSidebarOpen(true)}
          title={title}
          subtitle={subtitle}
          actions={actions}
          hasIssue={hasIssue}
          issueLabel={issueLabel}
        />

        <main className={`min-w-0 flex-1 overflow-y-auto px-4 pb-8 lg:px-5 ${contentTop === "compact" ? "pt-[4.25rem]" : "pt-[6.75rem]"}`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminPageLayout;
